import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface Feedback {
  name: string;
  api_token: string;
}

export interface FeedbackDetaiInfor {
  errors: unknown;
  Feedback: Feedback;
  isAuthenticated: boolean;
}

@Module
export default class FeedbackDetail
  extends VuexModule
  implements FeedbackDetaiInfor
{
  errors = {};
  Feedback = {} as Feedback;
  isAuthenticated = !!JwtService.getToken();

  /**
   * Get current user object
   * @returns User
   */
  get FeedbackDetail() {
    return this.feedbackDetailData;
  }

  /**
   * Verify user authentication
   * @returns boolean
   */

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors = { ...error };
  }

  @Mutation
  [Mutations.FEEDBACK_DETAIL_DATA](Feedback) {
    this.feedbackDetailData = Feedback;
  }
  @Action
  [Actions.FEEDBACK_DETAIL](payload) {
    return ApiService.getDataDetail("/feedback", payload, "detail", payload)
      .then(({ data }) => {
        this.context.commit(Mutations.FEEDBACK_DETAIL_DATA, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
      });
  }
}
